import { createContext, useContext } from 'react';

/*
  LayoutContext exposes app-shell affordances to the pages rendered inside it.

  Currently it carries `onMenuClick` — the mobile nav drawer toggle — so that
  each page's header can host the hamburger button itself (via MobileMenuButton)
  instead of relying on a separate floating button overlaid on the content.
*/
const LayoutContext = createContext({ onMenuClick: null });

export const LayoutProvider = LayoutContext.Provider;

export const useLayout = () => useContext(LayoutContext);

export default LayoutContext;
